<div class="modal-header">
    <h4 class="modal-title" id="modal-title">Detalles de Dirección</h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Cerrar"
        (click)="activeModal.dismiss('Cierre con X')"></button>
</div>
<div class="modal-body">
    <div *ngIf="isLoading" class="text-center">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p>Cargando información...</p>
    </div>

    <div *ngIf="!isLoading && errorMessage" class="alert alert-warning">
        {{ errorMessage }}
    </div>

    <div *ngIf="!isLoading && !errorMessage && empresa">
        <h5>
            Empresa: {{ empresa.razonSocial || 'N/A' }} (NIT:
            {{ empresa.nit || 'N/A' }})
        </h5>
        <hr />
        <dl class="row">
            <dt class="col-sm-3">Dirección Completa:</dt>
            <dd class="col-sm-9">{{ direccionFormateada }}</dd>

            <dt class="col-sm-3">Departamento:</dt>
            <dd class="col-sm-9">
                {{
                    empresa.direccion?.municipio?.departamento?.nombre || 'N/A'
                }}
            </dd>

            <dt class="col-sm-3">Municipio:</dt>
            <dd class="col-sm-9">
                {{ empresa.direccion?.municipio?.nombre || 'N/A' }}
            </dd>

            <dt class="col-sm-3">Zona:</dt>
            <dd class="col-sm-9">{{ empresa.direccion?.zona || 'N/A' }}</dd>

            <dt class="col-sm-3">Complemento:</dt>
            <dd class="col-sm-9">
                {{ empresa.direccion?.complemento || 'N/A' }}
            </dd>
        </dl>
    </div>
    <div *ngIf="!isLoading && !errorMessage && !empresa">
        <p>No se pudo cargar la información de la empresa.</p>
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="activeModal.close('Cerrar click')">
        Cerrar
    </button>
</div>
